module.exports = __webpack_public_path__ + "img/logo3.4099c1c0.png";